declare const __BACKEND_MAP__: Record<string, string>;

const hostname = window.location.hostname;
const backendMap = __BACKEND_MAP__;

let apiEndpoint;

if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
  apiEndpoint = backendMap.localDev;
} else {
  if (hostname.includes("dev")) {
    apiEndpoint = backendMap.dev;
  } else if (hostname.includes("staging")) {
    apiEndpoint = backendMap.staging;
  } else if (hostname.includes("prod") || hostname.includes("loginradius.com")) {
    apiEndpoint = backendMap.prod;
  }
}

export default {
  version: "1.0.0",
  apiEndpoint
};
